var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn btn-bg flexx pobtn mt-4 p-3 btn-primary btn-sm btn-block",attrs:{"block":"","size":"sm","id":"btn-bg","variant":"primary"}},[_c('i',{class:_vm.fas}),_c('span',{staticClass:"btn-com"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }